<template>
  <div
    class="dy"
    v-if="companyId == '4af9a23d97084ca49b83567adad5ad8b'"
  >
    <router-link to="/home">
      <el-button :type="$route.path == '/home' ? 'primary' : ''">
        首页
      </el-button></router-link
    >
    <div style="display:inline-block;width:10px;"></div>
    <router-link to="/publish">
      <el-button :type="$route.path == '/publish' ? 'primary' : ''"
        >发布求购
      </el-button></router-link
    >
    <div style="display:inline-block;width:10px;"></div>
    <!-- <el-button disabled>发布转让</el-button> -->
        <i
      class="el-icon-user"
      style="font-size:20px;color: #409EFF; margin-right:5px; margin-top:2px;"
    ></i>
    <h4 style="margin-right:30px;">
      {{ userName }}
    </h4>

  </div>
</template>
<script>
export default {
  data() {
    return {
      userName: localStorage.getItem("userName"),
      companyId:  localStorage.getItem("companyId")
    };
  },
};
</script>
